<template>
  <!-- Featured Item -->
  <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
    <Slide v-for="record in Similar" :key="record.id">
      <div class="featured-venues-item">
        <div class="listing-item listing-item-grid">
          <div class="listing-img">
            <router-link to="/coaches/coach-detail">
              <img
                :src="require(`@/assets/img/featured/${record.Image}`)"
                alt="Coaches"
              />
            </router-link>
            <div class="fav-item-venues">
              <span class="tag tag-blue">{{ record.Badge }}</span>
              <div class="list-reviews coche-star">
                <a
                  href="javascript:void(0)"
                  class="fav-icon"
                  @click="toggleSelected(item)"
                >
                  <i class="feather-heart"></i>
                </a>
              </div>
            </div>
            <div class="hour-list">
              <h5 class="tag tag-primary">From {{ record.Price }} <span>/hr</span></h5>
            </div>
          </div>
          <div class="listing-content text-start">
            <h3 class="listing-title">
              <router-link to="/coaches/coach-detail">{{ record.Name }}</router-link>
            </h3>
            <ul class="mb-2">
              <li>
                <span> <i class="feather-map-pin me-2"></i>{{ record.Location }} </span>
              </li>
            </ul>
            <div class="listing-details-group">
              <p>
                {{ record.Content }}
              </p>
            </div>
            <div class="coach-btn">
              <ul>
                <li>
                  <router-link to="/coaches/coach-detail" class="btn btn-primary w-100"
                    ><i class="feather-eye me-2"></i>View Profile</router-link
                  >
                </li>
                <li>
                  <router-link to="/coaches/coach-detail" class="btn btn-secondary w-100"
                    ><i class="feather-calendar me-2"></i>Book Now</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="avalbity-review">
              <ul>
                <li>
                  <div class="avalibity-date">
                    <span><i class="feather-calendar"></i></span>
                    <div class="avalibity-datecontent">
                      <h6>Next Availabilty</h6>
                      <h5>{{ record.Day }}</h5>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="list-reviews mb-0">
                    <div class="d-flex align-items-center">
                      <span class="rating-bg">4.5</span><span>{{ record.Reviews }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Slide>
    <template #addons>
      <Navigation />
    </template>
  </Carousel>
  <!-- /Featured Item -->
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Similar from "@/assets/json/similar-coaches.json";
export default {
  data() {
    return {
      Similar: Similar,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>
